<template>
  <div v-if="bodyShow" class="Knowledge-content">
    <!-- radio -->
    <div v-for="(item,index) in list" :key="index">
      <div v-if="item.type=='radio'" :class="['radio-group',(item.error || testBool)?'on':'']">
        <!-- 标题 -->
        <h3 v-html="item.question"></h3>
        <!-- 单选框 -->
        <div class="radio-identity">
          <div v-for="(itm,idx) in item.answer" :key="idx" :class="['identity',(item.error || testBool) && index<list.length-1?'on':'']">
            <label :class="['icon',itm.str_id==item.val?'on':'',item.error?'error':'']" :for="item.id+itm.str_id">
              <input :disabled="item.error" :id="item.id+itm.str_id" type="radio" @change="foceUpdateHandle" :value="itm.str_id" v-model="item.val" />
            </label>
            <label class="text" :for="item.id+itm.str_id">{{itm.str}}
              <img class="error-img" v-if="item.error && item.error==itm.str_id" src="@a/k_error.png" alt="">
            </label>
          </div>
        </div>
        <!-- 解析 -->
        <div v-if="(item.error || testBool)" class="parsing">
          <h4>【解析】</h4>
          <h4 class="on" v-if="item.error">正确答案：<span>{{item.result}}</span></h4>
          <div class="parsing-content" v-html="item.result_explain"></div>
        </div>
      </div>
      <!-- checkbox -->
      <div v-if="item.type=='checkbox'" :class="['familiarity',(item.error || testBool) && index<list.length-1?'on':'']">
        <!-- 标题 -->
        <h3 v-html="item.question"></h3>
        <!-- ,(item.error&& item.result.split(',').includes(cItem.str_id) && !item.val.includes(cItem.str_id))?'success':'' -->
        <div v-for="(cItem,cIndex) in item.answer" :key="cIndex" :class="['checkbox-group',(item.error || testBool)?'on':'']">
          <label :class="['icon',item.val.includes(cItem.str_id)?'on':'',(item.error&& !item.result.split(',').includes(cItem.str_id)&& item.val.includes(cItem.str_id))?'error':'']" :for="item.id+cItem.str_id">
            <input :disabled="item.error" :id="item.id+cItem.str_id" type="checkbox" @change="foceUpdateHandle" :value="cItem.str_id" v-model="item.val" />
          </label>
          <label class="checkbox-text" :for="item.id+cItem.str_id">
            <span>{{cItem.str}}</span>
            <img class="error-img" v-if="(item.error&& !item.result.split(',').includes(cItem.str_id)) && item.val.includes(cItem.str_id)" src="@a/k_error.png" alt="">
          </label>
        </div>
        <!-- 解析 -->
        <div v-if="(item.error || testBool)" class="parsing">
          <h4>【解析】</h4>
          <h4 class="on" v-if="item.error">正确答案：<span>{{item.result}}</span></h4>
          <div class="parsing-content" v-html="item.result_explain"></div>
        </div>
      </div>
    </div>
    <!-- <p class="error-prompt" v-if="isOkBool">
      *你距离牛逼就差{{errorList.length}}道题了，要不然再想想<span v-for="(sitem,sindex) in errorList" :key="sindex">第{{sitem+1}}题<font v-if="sindex<errorList.length-1">、</font></span>的答案，你是最棒的~
    </p> -->
    <!-- submit -->
    <a @click="doSubmit()" v-if="isOkBool==1"  :class="['submitBtn',boolShow?'on':'']">剑指要点</a>
    <a @click="doSubmit()" v-else-if="isOkBool==2" :class="['submitBtn',boolShow?'on':'']">知识晶体</a>
    <a @click="submitHandle()" v-else :class="['submitBtn',boolShow?'on':'']">提交</a>
    <!-- 关卡介绍 -->
    <public-level :level_list_id="level_list_id"></public-level>
  </div>
</template>
<script>
import { audioTest, testSubmit} from "@/api/course";
import { shareCon} from "@/utils/wxconfig";
import PublicLevel from '@c/course/public-level'
import Bus from "@/utils/bus"
export default {
  data() {
      return {
        bodyShow: false,
        data: {},
        list: [],
        boolShow: false,
        isOkBool: 0,
        errorList: [],
        query: '',
        testBool:false,
        level_list_id:''
      };
    },
    components:{
      PublicLevel
    },
    methods: {
      /*
       *@Description: 答题是否正确
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-21 11:10:14
       */
      isOk() {
        let b = true;
        for (let i = 0; i < this.list.length; i++) {
          let item = this.list[i],
            index = i;
          let bool = false;
          if (item.val instanceof Array) {
            item.val.forEach((m, idx) => {
              if (!item.result.split(',').includes(m) || item.result.split(',').length!=item.val.length) {
                bool = true;
              }
            });
          } else if (item.val != item.result) {
            bool = true;
          }
          if (bool) {
            this.$forceUpdate();
            if (item.val instanceof Array) {
              let result = new Set(item.result.split(',')),
                val = new Set(item.val);
              // 判断所选的答案是否正确并取出错误的选项
              let err1 = Array.from(new Set([...val].filter(x => !result.has(x))));
              // 判断是否选择正确答案并且取出未选择的正确答案
              let err2 = Array.from(new Set([...result].filter(x => !val.has(x))));
              let err = [...err1,...err2];
              if (err && err.length > 0) {
                item.error = err;
                this.errorList.push(i);
              }
            } else {
              this.errorList.push(i);
              item.error = item.val;
            }
            b = false;
          }
        }
        if(b){
          this.isOkBool = 2;
        }else{
          this.isOkBool = 1;
        }
        
      },
      doSubmit() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        let arr = [];
        this.list.forEach((item, index) => {
          arr.push({
            id: item.id,
            content: JSON.stringify(item.val)
          });
        });
        testSubmit({
          cid: this.$route.query.cid,
          field: arr
        }).then((data) => {
          this.$toast.clear();
          this.$toast.success({
            duration: 1000,
            message:data.msg,
            onClose:()=>{
              this.$router.push({
                path: '/knowledge_card',
                query: {
                  cid: this.query.cid,
                  testid: this.query.testid,
                  table_id: this.query.table_id,
                  cpid: this.query.cpid,
                  level_list_id:this.$route.query.level_list_id
                }
              });
            }
          });
        });
      },
      /*
       *@Description: 提交数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-20 18:37:10
       */
      submitHandle() {
        this.testBool = true;
        // 判断是否有数据为空
        if (this.boolShow) {
          this.isOk();
        } else {
          this.$toast("数据信息不能为空！");
        }

      },
      /*
       *@Description: 验证非空
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-20 18:12:44
       */
      validationHandle() {
        let bool = true;
        this.list.forEach((item, index) => {
          if (item.type == 'checkbox') {
            if (item.val.length == 0) {
              bool = false;
              return
            }
          } else {
            if (item.val == '') {
              bool = false;
              return
            }
          }
        });
        this.boolShow = bool;
      },
      /*
       *@param:
       *@return:
       *@Description: 重新渲染视图和检查数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-20 17:23:37
       */
      foceUpdateHandle(val, id) {
        this.$forceUpdate();
        this.validationHandle();
      },
      /*
       *@param:
       *@return:
       *@Description: 初始化方法
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-20 15:01:56
       */
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        let q = this.$route.query;
        this.level_list_id = q.level_list_id?q.level_list_id:'';
        audioTest({
          cid: q.cid,
          testid: q.testid,
          table_id: q.table_id,
          cpid: q.cpid
        }).then(data => {
          this.list = data.list;
          // 是否提交过数据
          if (data.subfield && data.subfield.length > 0) {
            this.list.forEach((item, index) => {
              // 判断是否是复选框
              if (item.type == "checkbox") {
                item["val"] = item.result.split(',');
              } else {
                item["val"] = item.result;
              }
            });
          } else {
            this.list.forEach((item, index) => {
              // 判断是否是复选框
              if (item.type == "checkbox") {
                item["val"] = [];
              } else {
                item["val"] = "";
              }
            });
          }
          this.validationHandle();
          this.bodyShow = true;
          this.$toast.clear();
          this.query = this.$route.query;
        });
      }
    },
    created() {
      Bus.$on('documentTitle',(data)=>{
        document.title = data.level.name;
      });
      this.pullData();
      // 分享
      shareCon("course", this);
    }
};
</script>
<style lang="scss">
body {
  background-color: #ffffff;
}
</style>
<style lang="scss">
.Knowledge-content {
  padding: 40px 0 80px;
  .radio-group {
    padding: 0 30px;
    h3 {
      font-size: 36px;
      color: #333333;
      line-height: 48px;
    }
    .radio-identity {
      margin-top: 34px;
      .identity {
        display: flex;
        color: #333333;
        // align-items: center;
        line-height: 40px;
        font-size: 32px;
        margin-top: 18px;
        &:last-child {
          margin-bottom: 70px;
        }
        label.text {
          flex: 1;
          line-height: 48px;
        }
        .error-img {
          width: 32px;
          height: 32px;
          margin-left: 30px;
        }
        label.icon {
          margin-top: 7px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          width: 38px;
          height: 38px;
          border: 2px solid #cccccc;
          box-sizing: border-box;
          background-color: #ffffff;
          border-radius: 50%;
          margin-right: 16px;
          input[type="radio"] {
            display: none;
            border: 0;
            outline: 0 !important;
            background-color: transparent;
            -webkit-appearance: none;
          }
        }
        label.icon.on {
          background-color: #eb5032;
          &:after {
            display: block;
            content: "";
            width: 18px;
            height: 18px;
            background-color: #ffffff;
            border-radius: 50%;
          }
        }
        label.icon.on.error {
          background-color: #CCCCCC;
        }
        label.icon.error.success {
          background: url(../../../assets/radio_success.png) center no-repeat;
          background-size: 100% 100%;
          border: none;
        }
      }
      .identity.on{
        &:last-child {
          margin-bottom: 50px;
        }
      }
    }
  }
  .familiarity {
    display: flex;
    color: #333333;
    flex-direction: column;
    padding: 0 30px;
    font-size: 32px;
    h3 {
      font-size: 36px;
      color: #333333;
      line-height: 48px;
      margin-bottom: 34px;
    }
    .checkbox-group {
      display: flex;
      align-items: flex-start;
      margin-bottom: 18px;
      &:last-child {
        margin-bottom: 70px;
      }
      label.checkbox-text {
        flex: 1;
        line-height: 48px;
        .error-img {
          width: 32px;
          height: 32px;
          margin-left: 30px;
        }
      }
      label.icon {
        display: block;
        position: relative;
        width: 36px;
        height: 36px;
        border: 2px solid #cccccc;
        box-sizing: border-box;
        background-color: #ffffff;
        border-radius: 4px;
        margin-right: 20px;
        margin-top: 7px;
        input[type="checkbox"] {
          display: none;
          border: 0;
          outline: 0 !important;
          background-color: transparent;
          -webkit-appearance: none;
        }
      }
      label.icon.on {
        background: url(../../../assets/press.png) center no-repeat;
        background-size: 100% 100%;
        border: none;
      }
      label.icon.error {
        background: url(../../../assets/check_error.png) center no-repeat;
        background-size: 100% 100%;
        border: none;
      }
      label.icon.success {
        background: url(../../../assets/check_success.png) center no-repeat;
        background-size: 100% 100%;
        border: none;
      }
    }
    .checkbox-group.on{
      &:last-child {
        margin-bottom: 50px;
      }
    }
  }
  .radio-group.on,.familiarity.on{
    border-bottom: 2px solid #F0F0F0;
    margin-bottom: 50px;
  }
  .submitBtn {
    display: block;
    margin: 0 auto;
    height: 66px;
    width: 174px;
    border-radius: 33px;
    background-color: #cccccc;
    color: #ffffff;
    font-size: 34px;
    line-height: 66px;
  }
  .submitBtn.on {
    background-color: #EB5032;
  }
  .error-prompt {
    font-size: 32px;
    color: #E2AF00;
    margin-bottom: 70px;
  }
  .parsing{
    margin-bottom: 50px;
    h4{
      font-size: 32px;
      color: #E2AF00;
      margin-bottom: 30px;
      line-height: 1;
      span{
        font-size: 32px;
        color: #333333;
      }
    }
    h4.on{
      margin-bottom: 20px;
    }
  }
}
</style>
